import { createApi } from '@reduxjs/toolkit/query/react';
import { transformResponses } from 'src/app-redux/rtkq.interceptor';
import type { Bid } from 'src/bidding/Bidding';
import { apiResources } from 'src/common/Constants';
import { baseQueryWithAuth } from '../rtkq.interceptor';

const bidsTag = 'bids';

/** RTK Query API slice for bid-related endpoints. */
export const bidsApi = createApi({
  reducerPath: 'bidsApi',
  tagTypes: [bidsTag],
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    /** Query to fetch all bids for a specific booking by booking ID. */
    fetchBookingBids: builder.query<Array<Bid>, number>({
      providesTags: [bidsTag],
      query: (bookingId) => `${apiResources.bid}/booking/${bookingId}`,
      ...transformResponses,
    }),
  }),
});

/** RTK Query hook for fetching booking bids. */
export const { useFetchBookingBidsQuery } = bidsApi;
